var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.asyncDataStatus_ready)?_c('div',{staticClass:"col-full push-top"},[_c('h2',[_vm._v("\n    Dodajte nov tip uporabnika:\n  ")]),_c('UserTypeForm',{attrs:{"new":"true"},on:{"save":_vm.save,"cancel":_vm.cancel}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }